export enum AirlockFormType {
  Appeal = 'appeal',
  Attestation = 'attestation',
  DataAccessRequest = 'data-access-request',
  ExportRequest = 'export-request',
  ImportRequest = 'import-request'
}

export interface WorkspaceConfigurationForm {
  id: string
  type: AirlockFormType
  name: string
}

export interface AirlockAccessPolicySettings {
  enabled?: boolean
  autoSharingOnApprovalEnabled?: boolean
  additionalInformationFormId?: string
  additionalInformationAvailable?: boolean
}

export interface WorkspaceConfigurationPermissions {
  admins?: {
    enableImportFromComputer?: boolean
    enableSelfReviewRestriction?: boolean
    enableViewFile?: boolean
  }
  members?: {
    enableImportFromComputer?: boolean
    enableViewFile?: boolean
  }
}

export interface WorkspaceConfigurationPolicyUser {
  id: string
  name?: string
  email: string
}

/** Legacy GET /v2/workspaces/:id/configuration when named policies are disabled. */
export interface ConfigurationPublicViewV2 {
  enabled: boolean
  status: 'Enabled' | 'Disabled'
  bucketName?: string
  storageAccountName?: string
  containerName?: string
  downloadLinkExpiresInSeconds: number
  enableEmailDownloadLink: boolean
  permissions: WorkspaceConfigurationPermissions
  verifiedResults?: {
    autoApprove?: boolean
  }
  unverifiedResults?: {
    enabled?: boolean
    autoApprove?: boolean
    checks?: unknown[]
    projectId?: string
  }
}

/** Named-policy GET /v2/workspaces/:id/configuration (publicViewV3). */
export interface ConfigurationPublicViewV3 {
  _id: string
  name: string
  enabled: boolean
  provider: string
  downloadLinkExpiresInSeconds: number
  enableEmailDownloadLink: boolean
  permissions: WorkspaceConfigurationPermissions
  verifiedResults?: {
    autoApprove?: boolean
  }
  unverifiedResults?: {
    enabled?: boolean
    autoApprove?: boolean
    checks?: unknown[]
    projectId?: string
  }
  importSettings?: {
    enabled?: boolean
  }
  managers?: string[]
  forms?: WorkspaceConfigurationForm[]
  createdBy?: WorkspaceConfigurationPolicyUser | null
  modifiedBy?: WorkspaceConfigurationPolicyUser | null
  createdAt?: string
  enabledAt?: string | null
  disabledAt?: string | null
  approvedBucketName?: string
  approvedStorageAccountName?: string
  approvedContainerName?: string
  airlockAccess?: AirlockAccessPolicySettings
}

export type EmptyWorkspaceConfiguration = Record<string, never>

export type GetWorkspaceConfigurationResponse =
  | EmptyWorkspaceConfiguration
  | ConfigurationPublicViewV2
  | ConfigurationPublicViewV3
